<template>
    <info-screen
            class="startRegistration startRecovery"
            :title="$ml.get('startAccessRecoveryTitle')"
            :text="$ml.get('startAccessRecoveryText')"
            :action="nextScreen"
            :buttonText="$ml.get('startButtonText')"
            :titleH1="true"
    >
        <template slot="bottomLink">
            <custom-button
                    class="bottomButton"
                    :button-text="$ml.get('startAccessRecoveryButtonLogin')"
                    :action="login"
            ></custom-button>
        </template>
    </info-screen>
</template>

<script>
    import InfoScreen from "../../components/layout/info-screen";
    import CustomButton from "../../components/ui/custom-button";
    import Profile from "../../helpers/profile";

    export default {
        name: "infoAccessRecoveryPage",
        components: {CustomButton, InfoScreen},
        mounted () {
            Profile.setData({process: 'accessRecovery'});
        },
        methods: {
            nextScreen: function () {
//                this.$router.push({ name: 'AccessRecoverySetPhone'});
                this.$router.push({ name: 'AccessRecoveryLastName'});
            },

            login: function () {
                Profile.reset();
                this.$router.push({ name: 'LoginEnterLogin'});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .bottomButton {
        margin-bottom: 20px;
    }
</style>


<style lang="scss">
    @media (max-width: 600px) {
        .startRecovery {
            .logoPage.fullImg {
                height: 100px;
            }
            .infoScreen_content {
                height: calc(100vh - 214px);
            }
        }
    }
</style>